import { requester } from '@/libs/requester';
import { AT } from '@/libs/translation';
import { CertificationTypeS } from '../../Certification/outbound/share';
import type { UserPublicApiRequestType } from '../../Client/type';
import type { AuthTypeS } from '../outbound/share';
import type {
  AgreementControllerReqBodyType,
  ChangeEmailControllerReqBodyType,
  ChangePwControllerReqBodyType,
  ProfileChangeControllerReqBodyType,
  SigninControllerReqBodyType,
  SigninControllerResBodyType,
  SignupControllerReqBodyType,
  SignupControllerResBodyType,
  SnsDisconnectControllerReqBodyType,
  UserProfileType,
} from '../type';

export const postSignup = (form: SignupControllerReqBodyType) => {
  return requester.post<SignupControllerResBodyType>(`/${AT.language}/api/v1/auth/signup`, form);
};

export const postSignin = (form: SigninControllerReqBodyType) => {
  return requester.post<SigninControllerResBodyType>(`/${AT.language}/api/v1/auth/signin`, form);
};

export const postChangeProfile = (form: ProfileChangeControllerReqBodyType) => {
  return requester.post<UserProfileType>(`/${AT.language}/api/v1/member/profile`, form);
};

export const postChangePassword = (form: ChangePwControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/member/change-password`, form);
};

export const postChangeEmail = (form: ChangeEmailControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/member/change-email`, form);
};

export const postSnsDisconnect = (form: SnsDisconnectControllerReqBodyType) => {
  return requester.post<{ nickname: string }>(`/${AT.language}/api/v1/member/sns-disconnect`, form);
};

export const postEmailCertificationChangeEmail = (
  form: CertificationTypeS.CreateMemberEmailCertificationCheckEmailControllerReqBodyType,
) => {
  return requester.post(`/${AT.language}/api/v1/member/email-certification/change-email`, form);
};

export const postEmailCertificationSnsDisconnect = (
  form: CertificationTypeS.CreateMemberEmailCertificationCheckEmailControllerReqBodyType,
) => {
  return requester.post(`/${AT.language}/api/v1/member/email-certification/sns-disconnect`, form);
};

export const postVerifyEmail = (form: CertificationTypeS.VerifyMemberEmailCertificationControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/member/email/verify`, form);
};

export const postEmailCertificationCheckEmail = (
  form: CertificationTypeS.CreateMemberEmailCertificationCheckEmailControllerReqBodyType,
) => {
  return requester.post(`/${AT.language}/api/v1/member/email-certification/check-email`, form);
};

export const postEmailCertificationVerify = (
  form: CertificationTypeS.VerifyMemberEmailCertificationControllerReqBodyType,
) => {
  return requester.post(`/${AT.language}/api/v1/member/email-certification/verify`, form);
};

export const sessionCheck = (headers: UserPublicApiRequestType) => {
  return requester.get<AuthTypeS.GetSessionCheckResBodyType>(`/${AT.language}/api/public/v1/user/session_check`, {
    headers,
  });
};

export const postWithdraw = () => {
  return requester.post<{ redirect_url: string }>(`/${AT.language}/api/v1/member/withdraw`);
};

export const postAgreement = (body: AgreementControllerReqBodyType) => {
  return requester.post<{ redirect_url: string }>(`/${AT.language}/api/v1/member/agreement`, body);
};
